import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import CustomView_rowComponent from "./row-component"
import {
    SelectParent_RenderType
} from "../../../../../../../core/gd-ui/select-parent-new/@const"
import SelectParentsNew from "../../../../../../../core/gd-ui/select-parent-new/select-parents-new"
import {EntityType} from "../../../../../../../core/gd/const/item"
import {CheckboxType} from "../../../../../../../core/gd-components/checkbox/checkbox"
import ProjectSessionCollection from "../../../../../../../core/model2/project/collection"

type Props = {
    form                        : FormManager
    formFieldName               : string
    placeholder                 : string
    unselectIcon?               : string
    unselectLabel?              : string
    multiselectCheckboxType?    : CheckboxType //'default' | 'full-colored' | 'filled'

    parentsFor?                 : EntityType
    availableProjects?          : ProjectSessionCollection // collection of projects that can be shown in selector

    inheritedChildrenSelection? : boolean
    disabled?                   : boolean

    onParentSelect              : {(projects: ID[]):void}
}


// const debug = "SelectProjectMulti"
const debug = false

export default function SelectProjectMulti(props: Props) {

    const projects = props.form.getValue(props.formFieldName)

    debug && console.log(debug, 'render', projects)

    return (
        <CustomView_rowComponent label="Projects">
            <SelectParentsNew renderType                    = {SelectParent_RenderType.FORM}
                              parentsFor                    = {props.parentsFor}
                              availableProjects             = {props.availableProjects}
                              placeholder                   = {props.placeholder}
                              inheritedChildrenSelection    = {props.inheritedChildrenSelection}
                              multiselectCheckboxType       = {props.multiselectCheckboxType}
                              displayWorkspaceRoot          = {true}
                              unselectIcon                  = {props.unselectIcon}
                              unselectLabel                 = {props.unselectLabel}
                              projectIds                    = {projects}
                              disabled                      = {props.disabled}
                              onChange                      = {props.onParentSelect}/>
            <FormError form={props.form} name={props.formFieldName} />
        </CustomView_rowComponent>
    )
}

SelectProjectMulti.defaultProps = {
    formFieldName   : "projects",
    placeholder     : "All projects",
    unselectIcon    : "i5-select-all",
    unselectLabel   : "All projects",
}